module.exports = __webpack_public_path__ + "static/media/Element_16_treatments.68e20101.svg";